export default class Resource {
    type;
    title;
    sub_title;
    icon;

    constructor(props) {
        Object.assign(this, props);
    }

}
